"use client";

import React, { useEffect, useRef, useState } from "react";
import { ArrowRight, BookOpen } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheDigitalFrontier() {
  const [mousePos, setMousePos] = useState({
    x: 0,
    y: 0
  });
  const sectionRef = useRef<HTMLElement>(null);
  const {
    ref: contentRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      if (!sectionRef.current) return;
      const {
        clientX,
        clientY
      } = e;
      const {
        innerWidth,
        innerHeight
      } = window;
      const x = (clientX / innerWidth - 0.5) * 40;
      const y = (clientY / innerHeight - 0.5) * 40;
      setMousePos({
        x,
        y
      });
    };
    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);
  return <section data-section-id="224660" id="the-digital-frontier" ref={sectionRef} className="relative w-full min-h-[90vh] flex items-center justify-center overflow-hidden bg-background text-foreground">
      {}
      <div className="absolute inset-[-5%] w-[110%] h-[110%] bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687829/img/cyber_grid_particles.png)] transition-transform duration-300 ease-out will-change-transform opacity-20" style={{
      transform: `translate(${mousePos.x}px, ${mousePos.y}px) scale(1.02)`
    }} />
      
      {}
      <div className="absolute inset-0 bg-black/60 bg-gradient-to-t from-background via-background/40 to-transparent" />

      {}
      <div ref={contentRef} className={`relative z-10 flex flex-col items-center text-center px-6 w-full max-w-4xl mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <h1 className="font-default text-5xl md:text-7xl lg:text-8xl mb-6 tracking-tighter font-bold leading-tight bg-clip-text text-transparent bg-gradient-to-r from-[var(--chart-1)] to-white drop-shadow-[0_0_15px_rgba(133,230,28,0.3)]">
          SCALING THE BEYOND
        </h1>
        
        <p className="font-default text-lg md:text-xl text-muted-foreground max-w-[600px] mb-10 leading-relaxed">
          Apex IT Solutions delivers futuristic software development, cybersecurity, and AI automation. We build the digital infrastructure that powers tomorrow's industry leaders.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
          <Button asChild size="lg" className="bg-[var(--chart-1)] hover:bg-[var(--chart-1)]/90 text-[var(--primary-foreground)] border-none rounded-md px-8 h-14 text-base shadow-lg shadow-[var(--chart-1)]/20 transition-all duration-300">
            <Link to="/SolutionsPage">
              Launch Project
              <ArrowRight className="ml-2 size-5" />
            </Link>
          </Button>
          
          <Button asChild size="lg" variant="outline" className="bg-transparent border-white/20 text-white hover:bg-white/5 hover:text-[var(--chart-1)] hover:border-[var(--chart-1)] rounded-md px-8 h-14 text-base backdrop-blur-md transition-all duration-300">
            <Link to="/ConnectPage">
              <BookOpen className="mr-2 size-5" />
              Consultation
            </Link>
          </Button>
        </div>
      </div>

      {}
      <div className="absolute inset-0 pointer-events-none opacity-10 flex justify-around px-10">
        <div className="w-px h-full bg-white" />
        <div className="w-px h-full bg-white" />
        <div className="w-px h-full bg-white" />
        <div className="w-px h-full bg-white" />
      </div>
    </section>;
}